import RoutePath from 'router/path';
import { getPwcRedirectPath } from 'router/utils/getPwcRedirectPath';

import { AccountAccessLevel, AccountType } from 'types/account';
import { RouteSetup, RouteSetupFactory } from 'types/routing';

import { getAvailableRoutes } from './availableRoutes';
import { PartnerFeatures, getPartnerFeatures } from './features';
import { getMenuItems } from './menuItems';

export const getDefaultLoginRedirectRoute = (
  hasAccounts: boolean,
  accountType: AccountType | undefined,
  features: PartnerFeatures,
): string => {
  if (!hasAccounts) {
    return RoutePath.Profile.Root;
  }

  if (accountType === AccountType.Ramp) {
    return RoutePath.Ramp.Orders.Root;
  }

  return getPwcRedirectPath(features);
};

export const PartnerRouterSetup: RouteSetupFactory = ({ accountAccessLevel, hasAccounts, accountType, merchantFlags }): RouteSetup => {
  const accessLevel = (accountAccessLevel as AccountAccessLevel) ?? AccountAccessLevel.Viewer;
  const features = getPartnerFeatures(accountType, merchantFlags);

  return {
    availableRoutes: getAvailableRoutes(accountType, accessLevel, features),
    menuItems: getMenuItems(accountType, accessLevel, features),
    defaultLoginRedirectRoute: getDefaultLoginRedirectRoute(hasAccounts, accountType, features),
  };
};

export default PartnerRouterSetup;
